<template>
    <section class="footer">
    <div class="footer-div-wrap">
      <div class="footer-div-1">
        <div class="footer-div1-left">
          <img sizes="(max-width: 479px) 92vw, (max-width: 767px) 30vw, 176.234375px" srcset="@/assets/images/PriMeds_LogoNEW_White-p-500.png 500w, @/assets/images/PriMeds_LogoNEW_White-p-800.png 800w, @/assets/images/PriMeds_LogoNEW_White.png 1030w" alt="" src="@/assets/images/PriMeds_LogoNEW_White.png" loading="lazy" class="footer-logo">
          <div class="text-block-1220 mobfooter" style="">13575 58th St N Ste 200<br>Clearwater, FL 33760<br>  <a href="mailto:support@prioritymeds.com"  style="font-size: 12px;color: #fff;">support@prioritymeds.com</a> <br/> <a href="tel:844-764-0646"  style="font-size: 12px;color: #fff;"> 844-764-0646 </a></div>
        </div>

        <div class="footer-div1-right">
          
          <div class="footer-column-div legal">
            <div class="footer-header">Legal</div>
            <div class="footer-text-link">
              <a :href="`${appMainWeb}/hipaa`" target="_blank" class="link-63">HIPAA Notice</a>
            </div>
            <div class="footer-text-link">
              <a :href="`${appMainWeb}/privacy`" target="_blank" class="link-63">Privacy Policy</a>
            </div>
            <div class="footer-text-link">
              <a :href="`${appMainWeb}/returns`" target="_blank" class="link-63">Returns &amp; Refund Policy</a>
            </div>
            <div class="footer-text-link">
              <a :href="`${appMainWeb}/terms`" target="_blank" class="link-63">Terms Of Use</a>
            </div>
            <div class="footer-text-link">
              <a :href="`${appMainWeb}/telehealth-consent`" target="_blank" class="link-63">TeleHealth Consent</a>
            </div>
            <div class="footer-text-link">
              <a :href="`${appMainWeb}/sms-terms-conditions`" target="_blank" class="link-63">SMS Terms & Conditions</a>
            </div>
          </div>
          <div class="footer-column-div company">
            <div class="footer-header">Company</div>
            <div class="footer-text-link">
              <a href="https://prioritymeds.com/about/" target="_blank" class="link-63">About</a>
            </div>
          </div>
        </div><img loading="lazy" src="https://static.legitscript.com/seals/21343890.png" alt="" width="75" height="89" class="image-529">
      </div>
      <div class="footer-div-2">
        <div class="text-block-143">© {{getYear}} PRIORITY MEDS LLC. All rights reserved.</div>
        <div class="footer-div2-right"><img src="https://cdn.prod.website-files.com/6747323bbc66fe54bcf1e0a7/67474185537ea090e6043ed4_icon_card_visa.png" loading="lazy" alt="" class="image-2"><img src="https://cdn.prod.website-files.com/6747323bbc66fe54bcf1e0a7/6747418549e05f355cfbcd0c_icon_card_mastercard.png" loading="lazy" alt="" class="image-2"><img src="https://cdn.prod.website-files.com/6747323bbc66fe54bcf1e0a7/674741857c9a8d93a4d77b50_icon_card_amex.png" loading="lazy" alt="" class="image-2"></div>
      </div>
    </div>
  </section>
</template>
<script>
export default {
    name: 'footerComponent',
    data() {
        return {
          appMainWeb: process.env.VUE_APP_HOMEPAGE,
        }
    },
    computed: {
        getYear() {
            return new Date().getFullYear();
        },
    },

}
</script>
<style>
.footer-div-wrap {
    background-color: var(--pastel-blue);
    padding: 30px 8%;
}
.mobfooter{
  font-size: 12px;
  color: #fff;
  margin-top: -25px;
  font-weight: normal;
  line-height: 18px;
}
@media screen and (max-width: 479px) {
    .mobfooter {

        padding-top: 50px;

    }
}
</style>
